<template>
  <div class="personal-data">
    <navbar title="个人资料" left-text show-home></navbar>
    <div class="personal-data-wrapper">
      <ul class="data-list">
        <li class="van-hairline--bottom">
          <a href="javascript:;" >
              <span>手机号码</span>
              <span>{{userInfo ? userInfo.phone : '未登录'}}</span>
          </a>
        </li>
        <li class="van-hairline--bottom">
          <a href="javascript:;" @click="checkGender">
              <span>性别</span>
              <span>{{userGender}}</span>
          </a>
        </li>
        <li class="van-hairline--bottom">
          <a href="javascript:;" @click="checkBirthdy">
              <span>生日</span>
              <span>{{userInfo.birthday ? userInfo.birthday : '未知'}}</span>
          </a>
        </li>
      </ul>
      <!-- <div class="logout">
        <button @click="logout">退出登录</button>
      </div> -->
    </div>
    <popup v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="settingBirthdy"
        @cancel="cancelHandler"
      >
      </van-datetime-picker>
    </popup>
    <popup v-model="showcheckGender" position="top">
       <van-radio-group v-model="selectedGender">
          <van-cell-group>
            <van-cell
              v-for="(gender, index) in genders"
              :key="index"
              :title="gender"
              clickable
              @click="taggleCell(gender, index + 1)">
              <van-radio slot="right-icon" :name="gender"  />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
    </popup>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Navbar from '../components/NavBar'
import { Popup, DatetimePicker, RadioGroup, Radio, Cell, CellGroup } from 'vant'
let flag = false
export default {
  name: 'personalData',
  components: {
    Navbar,
    Popup,
    VanDatetimePicker: DatetimePicker,
    VanRadioGroup: RadioGroup,
    VanRadio: Radio,
    VanCellGroup: CellGroup,
    VanCell: Cell
  },
  data () {
    return {
      currentDate: new Date(),
      minDate: new Date(1957, 12, 1),
      maxDate: new Date(),
      showDatetimePicker: false,
      showcheckGender: false,
      genders: ['男', '女'],
      selectedGender: ''
    }
  },
  computed: {
    ...mapState('store', ['userInfo']),
    userGender () {
      switch (this.userInfo.sex) {
        case 1:
          return '男'
        case 2:
          return '女'
        default:
          return '未知'
      }
    }
  },
  methods: {
    ...mapMutations('store', [
      'updateUserInfoHandler'
    ]),
    ...mapActions('store', [
      'setAuthorizationHandler',
      'setUserInfo'
    ]),
    taggleCell (gender, index) {
      this.selectedGender = gender
      this.showcheckGender = false
      this.updateUserInfo({ sex: index })
    },
    settingBirthdy (e) {
      this.showDatetimePicker = false
      const y = e.getFullYear()
      const m = e.getMonth() + 1
      const d = e.getDate()
      this.userBirthday = `${y}-${m}-${d}`
      this.updateUserInfo({ birthday: this.userBirthday })
      // this.userBirthday = e.toLocaleDateString()
    },
    cancelHandler () {
      this.showDatetimePicker = false
    },
    checkGender () {
      this.showcheckGender = true
    },
    checkBirthdy () {
      this.showDatetimePicker = true
    },
    async updateUserInfo (arg) {
      this.$toast.loading('请稍后...')
      const res = await this.$axios.post('api/member/update', arg)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('修改成功')
          this.updateUserInfoHandler(arg)
        } else {
          this.$toast(msg)
        }
      }
    },
    logout () {
      if (flag) {
        return false
      }
      flag = true
      this.setAuthorizationHandler(null)
      this.setUserInfo(null)
      this.selectedGender = '未知'
      this.userBirthday = '请完善'
      this.$toast('退出成功')
      setTimeout(() => {
        this.$router.push({ name: 'home' })
        flag = false
      }, 2000)
    }
  }
}
</script>

<style lang="less" scoped>
.personal-data {
  .personal-data-wrapper {
    margin: 0.5rem 0;
    .data-list {
      a {
        .flex-between;
        height: 0.88rem;
        padding: 0 0.42rem;
        font-size: @fz28;
        color: @base;
        background-color: #fff;
      }
    }
    .logout {
      text-align: center;
      margin-top: 0.5rem;
      button {
        width: 6.8rem;
        height: 0.88rem;
        color: #fff;
        font-size: @fz24;
        background-color: #3498DB;
        border-radius: 30px;
      }
    }
  }
}
</style>
